export default "__VITE_ASSET__BAW$8hOE__"